export default "__VITE_ASSET__BALjo6yS__"